"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.Logo = exports.Container = exports.Button = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Button = styled_components_1.default.button `
  padding: 0;
  border: 0;
  margin: 0;

  background: unset;

  font: inherit;
  font-size: 100%;

  vertical-align: baseline;
`;
exports.Container = styled_components_1.default.div `
  display: flex;
  align-items: center;

  margin-bottom: ${({ theme }) => theme.space.s100};

  :hover {
    cursor: pointer;
  }
`;
exports.Logo = styled_components_1.default.img `
  height: 28px;

  margin-right: ${({ theme }) => theme.space.s100};
`;
exports.Text = styled_components_1.default.p `
  ${({ theme }) => theme.typography.body.tinyText};
`;
